import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  CircularProgress,
} from "@mui/material";

const EmailLoginModel = ({
  isEmailLoginOpen,
  handleCloseEmailLogin,
  handleEmailVerificationRequest,
  handleEmailLogin,
  error,
  prefillEmail,
}) => {
  const [email, setEmail] = useState(prefillEmail || "");
  const [verificationCode, setVerificationCode] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (prefillEmail) setEmail(prefillEmail);
  }, [prefillEmail]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await handleEmailVerificationRequest(email);
    if (ok) setStep(2);
    setLoading(false);
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    await handleEmailLogin(email, verificationCode);
    setLoading(false);
  };

  const handleClose = () => {
    setStep(1);
    setEmail("");
    setVerificationCode("");
    handleCloseEmailLogin();
  };

  return (
    <Modal open={isEmailLoginOpen} onClose={handleClose}>
      <Box
        component="form"
        onSubmit={step === 1 ? handleSendCode : handleVerifyCode}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          maxWidth: "350px",
          backgroundColor: "white",
          margin: "auto",
          borderRadius: "8px",
          mt: "15%",
          boxShadow: 24,
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={3}>
          {step === 1 ? "Login with Email" : "Enter Verification Code"}
        </Typography>

        <Typography variant="body2" color="textSecondary" mb={3}>
          {step === 1
            ? "Enter your email to receive a verification code"
            : `We sent a code to ${email}`}
        </Typography>

        {step === 1 ? (
          <>
            <TextField
              fullWidth
              margin="normal"
              required
              type="email"
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </>
        ) : (
          <>
            <TextField
              fullWidth
              margin="normal"
              required
              label="Verification Code"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="Enter 6-digit code"
            />
          </>
        )}

        {error && (
          <Typography color="error" mt={2}>
            {error}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            mt: 3,
            mb: 2,
            color: "white",
            fontWeight: "bold",
            width: "100%",
            height: "45px",
          }}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : step === 1 ? (
            "Send Code"
          ) : (
            "Verify & Login"
          )}
        </Button>

        {step === 2 && (
          <Button
            onClick={() => setStep(1)}
            sx={{
              textTransform: "none",
            }}
          >
            Use different email
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default EmailLoginModel;
